/* 
* <license header>
*/

import actionWebInvoke from '../../utils'
import allActions from '../../config.json'

const KEYS = {
  items: 'prj-concurrent-demo/voting-items',
  stats: 'prj-concurrent-demo/voting-stats',
  vote: 'prj-concurrent-demo/voting-vote',
  reset: 'prj-concurrent-demo/voting-reset'
}

function url (key) {
  const u = allActions[KEYS[key]]
  if (!u) {
    throw new Error(`Missing action URL for ${KEYS[key]} in config.json`)
  }
  return u
}

function imsHeaders (ims) {
  const h = {}
  if (ims && ims.token) h.Authorization = `Bearer ${ims.token}`
  if (ims && ims.org) h['x-gw-ims-org-id'] = ims.org
  return h
}

export function hasImsForReset (ims) {
  return Boolean(ims && ims.token && ims.org)
}

export async function fetchItems (bustCache = true) {
  const params = bustCache ? { t: String(Date.now()) } : {}
  return actionWebInvoke(url('items'), {}, params, { method: 'GET' })
}

/** Default bustCache=true so item names / stats are not stuck behind browser or CDN caches after deploy. */
export async function fetchStats (bustCache = true) {
  const params = bustCache ? { t: String(Date.now()) } : {}
  return actionWebInvoke(url('stats'), {}, params, { method: 'GET' })
}

export async function postVote (itemId) {
  return actionWebInvoke(url('vote'), {}, { itemId }, { method: 'POST' })
}

export async function postReset (ims) {
  return actionWebInvoke(url('reset'), imsHeaders(ims), {}, { method: 'POST' })
}
